"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 1000",
  "enable-background": "new 0 0 1000 1000",
  xmlSpace: "preserve",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0.000000,114.000000) scale(0.100000,-0.100000)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M4669.8,190.4c-238.1-384-975.4-1758.8-975.4-1820.2c0-23.1,591.4-46.1,1305.6-46.1c721.9,0,1305.6,23,1305.6,46.1c0,61.4-737.3,1436.2-975.4,1820.2c-107.5,169-238.1,284.2-330.2,284.2S4777.3,359.4,4669.8,190.4z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M2911-2996.9L2480.9-3788l1259.6-23c691.2-7.7,1827.9-7.7,2519.1,0l1259.6,23L7089-2996.9l-437.8,783.4H5000H3348.7L2911-2996.9z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1828.1-4993.8c-184.4-353.3-384-714.2-430.1-806.4l-92.2-176.6H5000h3701.9l-422.4,791.1l-430.1,783.4l-2834.1,23L2173.7-4364L1828.1-4993.8z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M522.4-7374.7L100-8165.8l2450-23c1344-7.7,3555.9-7.7,4900,0l2450,23l-422.4,791.1l-430.1,783.4H5000H952.5L522.4-7374.7z"
      })]
    })
  })
}));